const s = (t, r) => Object.fromEntries(Object.entries(t).map(([n, e]) => [r(e, n), e]));
export {
  s as mapKeys
};
